export interface ISpeciality {
    id?: string;
    label: string;
    arabicName: string;
    ref: string;
}

export default class Speciality implements ISpeciality {
    id?: string | undefined;
    label: string;
    arabicName: string;
    ref: string;

    constructor(other?: Partial<ISpeciality>) {
        this.id = other?.id;
        this.label = other?.label || '';
        this.arabicName = other?.arabicName || '';
        this.ref = other?.ref || '';

    }
    public static fromResponse(res: any): Speciality {
        return new Speciality({
            id: res.id || res.specialiteId,
            label: res.name || res.specialiteNom,
            arabicName: res.arabicName || res.specialiteNomarab,
            ref: res.ref
        })
    }
}